export const setAuthUserNumber = (num) => ({
  type:"SET_AUTH_USER_NUMBER",
  num
});

export const saveAuthUser = (authUser, index) => ({
  type:"SAVE_AUTH_USER",
  authUser,
  index
});

export const removeAuthUser = (index) => ({
  type:"REMOVE_AUTH_USER",
  index
});


// WEBPACK FOOTER //
// ./src/actions/authUserAction.js